import { TableCellLayout, createTableColumn } from "@fluentui/react-components";
import { ManageImplementationDocuments } from "components/ManageImplementationDocuments/ManageImplementationDocuments";
import { AddPackageCell } from "components/TableCells/AddPackageCell";
import { CarrierCell } from "components/TableCells/CarrierCell";
import { ConsentNeededCell } from "components/TableCells/ConsentNeededCell";
import { CoverPhotoCell } from "components/TableCells/CoverPhotoCell";
import { CurrencyCell } from "components/TableCells/CurrencyCell";
import { DateCell } from "components/TableCells/DateCell";
import { DescAsDocCell } from "components/TableCells/DescAsDocCell";
import DescCell from "components/TableCells/DescCell";
import { ImplementedBenefitActionsCell } from "components/TableCells/ImplementedBenefitActionsCell";
import { ImplementedBenefitNameCell } from "components/TableCells/ImplementedBenefitNameCell";
import { PolicyContractNumberCell } from "components/TableCells/PolicyContractNumberCell";
import { SelectInsurerCell } from "components/TableCells/SelectInsurerCell";
import { SelectPolicyCell } from "components/TableCells/SelectPolicyCell";
import { SelectWithYesNoOptionsCell } from "components/TableCells/SelectWithYesNoOptionsCell";
import { TypeOfConsentCellSingleSelect } from "components/TableCells/TypeOfConsentCellSingleSelect";
import { TFunction } from "i18next";
import {
  EInsurerConsentType,
  ETaxonomy,
  IBenefitCategory,
  IRowItem,
} from "library/types";
import styled from "styled-components";
import { InsurerConsentTypeCell } from "./InsurerConsentTypeCell";
import { EditableInputCell } from "../EditableInputCell";
import { SelectTaxonomyCell } from "../SelectTaxonomyCell";
import { InsurerFormCell } from "./InsurerFormCell";

type ColumnProps = {
  countryCode: string | number;
  clientInternalNumberGOS?: number;
  benefitCategoryTag?: number;
  withIncludedBenefits?: boolean;
  hasSelection?: boolean;
  benefitCategory?: IBenefitCategory;
  onlyActiveImplementations?: boolean;
  isReadOnlyUser?: boolean;
  t: TFunction;
};

type IHeaderItem =
  | {
      toggleAllRows: (e: any) => void;
      allRowsSelected: boolean;
      selectionMode: "single" | "multiselect";
      someRowsSelected: boolean;
      toggleAllKeydown: (e: any) => void;
    }
  | any;

export const getImplementedBenefitsColumnsDef = ({
  countryCode,
  clientInternalNumberGOS = 0,
  benefitCategoryTag,
  benefitCategory,
  isReadOnlyUser,
  onlyActiveImplementations,
  t,
}: ColumnProps) => [
  // ...(hasSelection
  //   ? [
  //       createTableColumn({
  //         columnId: "select",
  //         renderHeaderCell: (item: IHeaderItem) => {
  //           if (item.selectionMode === "multiselect") {
  //             return (
  //               <TableSelectionCell
  //                 checked={
  //                   item ? true : item.someRowsSelected ? "mixed" : false
  //                 }
  //                 onClick={(e) => {
  //                   if (item.selectionMode === "multiselect") {
  //                     item.toggleAllRows(e);
  //                   }
  //                 }}
  //                 onKeyDown={item.toggleAllKeydown}
  //                 checkboxIndicator={{ "aria-label": "Select all rows " }}
  //               />
  //             );
  //           }
  //           if (item.selectionMode === "single") {
  //             return <TableSelectionCell type="radio" invisible />;
  //           }
  //           return <></>;
  //         },
  //         renderCell: (item: IRowItem) => {
  //           if (!item.selectionMode) return <></>;
  //           if (item.selectionMode === "multiselect")
  //             return (
  //               <TableSelectionCell
  //                 checked={item.selected}
  //                 checkboxIndicator={{ "aria-label": "Select row" }}
  //               />
  //             );
  //           if (item.selectionMode === "single") {
  //             return (
  //               <TableSelectionCell
  //                 checked={item.selected}
  //                 type="radio"
  //                 radioIndicator={{ "aria-label": "Select row" }}
  //               />
  //             );
  //           }
  //         },

  //         compare: (a, b) => {
  //           return (a?.benefitCategoryTag || 0) - (b?.benefitCategoryTag || 0);
  //         },
  //       }),
  //     ]
  //   : [
  //       createTableColumn({
  //         columnId: "id",
  //         renderHeaderCell: () => <>{columnNames.id}</>,
  //         renderCell: (item: IRowItem) => {
  //           return <TableCellLayout>{item.benefitCategoryTag}</TableCellLayout>;
  //         },

  //         compare: (a, b) => {
  //           return (a?.benefitCategoryTag || 0) - (b?.benefitCategoryTag || 0);
  //         },
  //       }),
  //     ]),
  createTableColumn({
    columnId: "coverPhoto",
    renderHeaderCell: () => <>{t("hbh.coverPicture.label")}</>,
    renderCell: (item: IRowItem) => {
      return <CoverPhotoCell item={item} disabled={isReadOnlyUser} />;
    },

    compare: (a, b) => {
      return (a?.coverPhoto?.name || "")?.localeCompare(
        b?.coverPhoto?.name || ""
      );
    },
  }),
  createTableColumn({
    columnId: "name",
    renderHeaderCell: () => <>{t("hbh.name.label")}</>,
    renderCell: (item: IRowItem) => {
      if (isReadOnlyUser) {
        return item.name;
      }
      return (
        <TableCellLayout>
          <ImplementedBenefitNameCell item={item} />
        </TableCellLayout>
      );
    },

    compare: (a, b) => {
      return (a?.name || "").localeCompare(b?.name || "");
    },
  }),
  // createTableColumn({
  //   columnId: "benefitCategoryName",
  //   renderHeaderCell: () => <>{t("hbh.benefitCategory.label")}</>,
  //   renderCell: (item: IRowItem) => {
  //     if (isReadOnlyUser) {
  //       return item.benefitCategoryName;
  //     }
  //     return <CategoryNameCell item={item} />;
  //   },

  //   compare: (a, b) => {
  //     return (a?.benefitCategoryName || "").localeCompare(
  //       b?.benefitCategoryName || ""
  //     );
  //   },
  // }),
  createTableColumn({
    columnId: "insurerConsentType",
    renderHeaderCell: () => <>{t("hbh.typeOfConsentInsurer.label")}</>,
    renderCell: (item: IRowItem) => {
      return (
        <SelectCellWrap>
          <InsurerConsentTypeCell item={item} readOnly={isReadOnlyUser} />
        </SelectCellWrap>
      );
    },
    compare: (a, b) => {
      return (a?.insurerConsentType?.toString() || "").localeCompare(
        b?.insurerConsentType?.toString() || ""
      );
    },
  }),

  createTableColumn({
    columnId: "insurerConsentUrl",
    renderHeaderCell: (data) => <>{t("hbh.consentUrl.label")}</>,
    renderCell: (item: IRowItem) => {
      const isUrlToInsurer =
        item?.insurerConsentType === EInsurerConsentType.URL_TO_INSURER;
      if (!isUrlToInsurer) return;

      return (
        <EditableInputCell
          item={item}
          fieldName="insurerConsentUrl"
          readOnly={isReadOnlyUser}
        />
      );
    },
    compare: (a, b) => {
      return (a?.insurerConsentUrl?.toString() || "").localeCompare(
        b?.insurerConsentUrl?.toString() || ""
      );
    },
  }),

  createTableColumn({
    columnId: "insurerConsentText",
    renderHeaderCell: () => <>{t("hbh.iAgreeText.label")}</>,
    renderCell: (item: IRowItem) => {
      const isIagreeText =
        item?.insurerConsentType === EInsurerConsentType.I_AGREE_TEXT;

      if (!isIagreeText) return;

      return (
        <EditableInputCell
          item={item}
          fieldName="insurerConsentText"
          readOnly={isReadOnlyUser}
        />
      );
    },
    compare: (a, b) => {
      return (a?.insurerConsentText?.toString() || "").localeCompare(
        b?.insurerConsentText?.toString() || ""
      );
    },
  }),
  createTableColumn({
    columnId: "insurerConsentDeliveryType",
    renderHeaderCell: () => <>{t("hbh.insurerConsentDeliveryType.label")}</>,
    renderCell: (item: IRowItem) => {
      const isInsurerForm =
        item?.insurerConsentType === EInsurerConsentType.INSURER_FORM;

      if (!isInsurerForm) return;
      return (
        <SelectTaxonomyCell
          readOnly={isReadOnlyUser}
          item={item}
          fieldName="insurerConsentDeliveryType"
          taxonomyName={ETaxonomy.DeliveryType}
        />
      );
    },
    compare: (a, b) => {
      return (a?.insurerConsentDeliveryType?.toString() || "").localeCompare(
        b?.insurerConsentDeliveryType?.toString() || ""
      );
    },
  }),
  createTableColumn({
    columnId: "insurerForm",
    renderHeaderCell: () => <>{t("hbh.consentDocument.label")}</>,
    renderCell: (item: IRowItem) => {
      const isInsurerForm =
        item?.insurerConsentType === EInsurerConsentType.INSURER_FORM;

      if (!isInsurerForm) return;
      return <InsurerFormCell item={item} disabled={isReadOnlyUser} />;
    },
  }),

  createTableColumn({
    columnId: "addPackage",
    renderHeaderCell: () => <>{t("hbh.addPackage.label")}</>,
    renderCell: (item: IRowItem) => {
      return (
        <TableCellLayout truncate>
          <AddPackageCell item={item} disabled={isReadOnlyUser} />
        </TableCellLayout>
      );
    },
  }),

  createTableColumn({
    columnId: "selectPolicy",
    renderHeaderCell: () => <>{t("hbh.selectPolicy.label")}</>,
    renderCell: (item: IRowItem) => {
      if (isReadOnlyUser) {
        return "";
      }
      return (
        <SelectCellWrap>
          <SelectPolicyCell item={item} />
        </SelectCellWrap>
      );
    },
  }),
  createTableColumn({
    columnId: "selectInsurer",
    renderHeaderCell: () => <>{t("hbh.selectInsurer.label")}</>,
    renderCell: (item: IRowItem) => {
      if (isReadOnlyUser) {
        return "";
      }
      return (
        <SelectCellWrap>
          <SelectInsurerCell item={item} />
        </SelectCellWrap>
      );
    },
  }),
  createTableColumn({
    columnId: "carrierName",
    renderHeaderCell: () => <>{t("hbh.carrier.label")}</>,
    renderCell: (item: IRowItem) => {
      if (isReadOnlyUser) {
        return item?.carrierName;
      }
      return (
        <TableCellLayout truncate>
          <CarrierCell item={item} />
        </TableCellLayout>
      );
    },
    compare: (a, b) => {
      return (a?.carrierName || "").localeCompare(b?.carrierName || "");
    },
  }),

  createTableColumn({
    columnId: "policyOrContractNumber",
    renderHeaderCell: () => <>{t("hbh.policyOrContractNumber.label")}</>,
    renderCell: (item: IRowItem) => {
      if (isReadOnlyUser) {
        return item?.policyOrContractNumber;
      }
      return (
        <TableCellLayout truncate>
          <PolicyContractNumberCell item={item} />
        </TableCellLayout>
      );
    },
    compare: (a, b) => {
      return (a?.policyOrContractNumber || "").localeCompare(
        b?.policyOrContractNumber || ""
      );
    },
  }),
  createTableColumn({
    columnId: "validFrom",
    renderHeaderCell: () => <>{t("hbh.validFrom.label")}</>,
    renderCell: (item: IRowItem) => {
      return (
        <TableCellLayout truncate>
          <DateCell
            item={item}
            fieldName="validFrom"
            readOnly={isReadOnlyUser}
          />
        </TableCellLayout>
      );
    },
    compare: (a, b) => {
      return (a?.validFrom || "").localeCompare(b?.validFrom || "");
    },
  }),
  createTableColumn({
    columnId: "validTo",
    renderHeaderCell: () => <>{t("hbh.validTo.label")}</>,
    renderCell: (item: IRowItem) => {
      return (
        <TableCellLayout truncate>
          <DateCell item={item} fieldName="validTo" readOnly={isReadOnlyUser} />
        </TableCellLayout>
      );
    },
    compare: (a, b) => {
      return (a?.validTo || "").localeCompare(b?.validTo || "");
    },
  }),
  createTableColumn({
    columnId: "packagesCount",
    renderHeaderCell: () => <>{t("hbh.packagesNumber.label")}</>,
    renderCell: (item: IRowItem) => {
      return (
        <TableCellLayout truncate>
          {item?.packagesCount?.toString()}
        </TableCellLayout>
      );
    },
  }),
  createTableColumn({
    columnId: "manageDocuments",
    renderHeaderCell: () => <>{t("hbh.documents.label")}</>,
    renderCell: (item: IRowItem) => {
      return (
        <ManageImplementationDocuments
          item={item}
          disabled={isReadOnlyUser}
          onlyActiveImplementations={onlyActiveImplementations}
        />
      );
    },

    compare: (a, b) => {
      return (a?.coverPhoto?.name || "")?.localeCompare(
        b?.coverPhoto?.name || ""
      );
    },
  }),

  createTableColumn({
    columnId: "consentNeeded",
    renderHeaderCell: () => <>{t("hbh.consentNeeded.label")}</>,
    renderCell: (item: IRowItem) => {
      return (
        <SelectCellWrap>
          <ConsentNeededCell item={item} readOnly={isReadOnlyUser} />
        </SelectCellWrap>
      );
    },

    compare: (a, b) => {
      return (a?.consentsNeeded ? 1 : 0) - (b?.consentsNeeded ? 1 : 0);
    },
  }),
  createTableColumn({
    columnId: "currencyCode",
    renderHeaderCell: () => <>{t("hbh.currency.label")}</>,
    renderCell: (item: IRowItem) => {
      return (
        <SelectCellWrap>
          <CurrencyCell item={item} readOnly={isReadOnlyUser} />
        </SelectCellWrap>
      );
    },

    compare: (a, b) => {
      return (a?.currencyCode ? 1 : 0) - (b?.currencyCode ? 1 : 0);
    },
  }),

  createTableColumn({
    columnId: "isAutoEnrollment",
    renderHeaderCell: () => <>{t("hbh.isAutoEnrollment.label")}</>,
    renderCell: (item: IRowItem) => {
      return (
        <SelectCellWrap>
          <SelectWithYesNoOptionsCell
            fieldName="isAutoEnrollment"
            item={item}
            readOnly={isReadOnlyUser}
          />
        </SelectCellWrap>
      );
    },

    compare: (a, b) => {
      return (a?.isAutoEnrollment ? 1 : 0) - (b?.isAutoEnrollment ? 1 : 0);
    },
  }),

  createTableColumn({
    columnId: "description",
    renderHeaderCell: () => <>{t("hbh.description.label")}</>,
    renderCell: (item: IRowItem) => {
      return (
        <InputCellWrap>
          <DescCell item={item} readOnly={isReadOnlyUser} />
        </InputCellWrap>
      );
    },

    compare: (a, b) => {
      return (a?.description || "").localeCompare(b?.description || "");
    },
  }),

  createTableColumn({
    columnId: "actionsCell",
    renderHeaderCell: () => (
      <div
        style={{
          textAlign: "center",
          width: "100%",
        }}
      >
        {t("hbh.actions.label")}
      </div>
    ),
    renderCell: (item: IRowItem) => {
      return (
        <ImplementedBenefitActionsCell
          onlyActiveImplementations={onlyActiveImplementations}
          disabled={isReadOnlyUser}
          item={item}
          countryCode={countryCode}
          clientInternalNumberGOS={clientInternalNumberGOS}
          benefitCategoryTag={
            benefitCategoryTag === undefined
              ? item?.benefitCategoryTag
              : benefitCategoryTag
          }
          benefitCategory={benefitCategory}
        />
      );
    },
  }),
];

export const defaultColumnSizingOptions = {
  id: {
    idealWidth: 30,
    minWidth: 30,
  },
  select: {
    idealWidth: 30,
    minWidth: 30,
  },
  benefitCategory: {
    idealWidth: 200,
    minWidth: 200,
  },
  name: {
    idealWidth: 200,
    minWidth: 200,
  },
  addPackage: {
    idealWidth: 130,
    minWidth: 130,
  },
  manageDocuments: {
    idealWidth: 260,
    minWidth: 260,
  },
  policyOrContractNumber: {
    idealWidth: 200,
    minWidth: 200,
  },
  currencyCode: {
    idealWidth: 200,
    minWidth: 200,
  },
  carrierName: {
    idealWidth: 200,
    minWidth: 200,
  },

  packagesCount: {
    idealWidth: 100,
    minWidth: 100,
  },
  validFrom: {
    idealWidth: 130,
    minWidth: 130,
  },
  validTo: {
    idealWidth: 130,
    minWidth: 130,
  },

  coverPhoto: {
    minWidth: 90,
    defaultWidth: 90,
  },

  consentNeeded: {
    minWidth: 80,
    defaultWidth: 80,
  },
  insurerConsentType: {
    minWidth: 280,
    defaultWidth: 280,
  },
  insurerConsentUrl: {
    minWidth: 250,
    defaultWidth: 250,
  },
  insurerConsentText: {
    minWidth: 250,
    defaultWidth: 250,
  },
  insurerConsentDeliveryType: {
    minWidth: 250,
    defaultWidth: 250,
  },
  insurerForm: {
    minWidth: 250,
    defaultWidth: 250,
  },

  enrollmentProcessNeeded: {
    minWidth: 150,
    defaultWidth: 150,
  },

  description: {
    minWidth: 220,
    defaultWidth: 220,
  },

  implementBenefit: {
    minWidth: 200,
    defaultWidth: 200,
  },
  selectPolicy: {
    minWidth: 300,
    defaultWidth: 300,
  },
  selectInsurer: {
    minWidth: 300,
    defaultWidth: 300,
  },

  actionsCell: {
    minWidth: 120,
    idealWidth: 120,
    defaultWidth: 120,
  },
};

const SelectCellWrap = styled.div`
  .fui-Select__select,
  .fui-Select__select:focus,
  .fui-Select__select:focus-within {
    border-bottom: none;
  }

  .fui-Combobox,
  .fui-Combobox:focus {
    border-bottom: none;
  }
`;

const InputCellWrap = styled.div`
  .fui-Input,
  .fui-Input:focus {
    border-bottom: none;
  }
`;
